/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import FileAttachment from "core/models/file-attachment";
import { task } from "ember-concurrency";
let FileAttachmentDisplayer = (_class = class FileAttachmentDisplayer extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    /**
     * Async loading of the file attachment content
     * into a variable, which will be used :
     * - to display an iFrame if the user is not on a mobile
     * - to allow user to download the file given its content and mimeType,
     *   because iFrame aren't supported on every mobile and browsers
     */
    _defineProperty(this, "retrieveDocumentContent", _buildTask(() => ({
      context: this,
      generator: function* (modifyDocumentContent) {
        const fileContent = yield this.fileAttachment.fileContent;
        modifyDocumentContent(fileContent.data);
      }
    }), null, "retrieveDocumentContent", null));
  }
  get mimeType() {
    return this.args.fileAttachment.mimeType;
  }
  get fileAttachment() {
    return this.args.fileAttachment;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { FileAttachmentDisplayer as default };